var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61 497c0 8.284 6.716 15 15 15h360c8.284 0 15-6.716 15-15v-46h-390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 120c-82.71 0-150 67.29-150 150v151h300v-151c0-82.71-67.29-150-150-150z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 90c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.894 111.202c4.155 7.197 13.336 9.62 20.49 5.49 7.175-4.142 9.633-13.316 5.49-20.49l-30-51.961c-4.143-7.175-13.316-9.632-20.49-5.49-7.175 4.142-9.633 13.316-5.49 20.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.192 188.616c4.143-7.174 1.685-16.348-5.49-20.49l-51.962-30c-7.175-4.143-16.349-1.685-20.49 5.49-4.143 7.174-1.685 16.348 5.49 20.49l51.962 30c7.143 4.125 16.33 1.716 20.49-5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.616 116.692c7.143 4.125 16.33 1.715 20.49-5.49l30-51.961c4.143-7.174 1.685-16.348-5.49-20.49-7.174-4.144-16.349-1.685-20.49 5.49l-30 51.961c-4.143 7.174-1.685 16.348 5.49 20.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m503.75 143.616c-4.143-7.175-13.315-9.631-20.49-5.49l-51.962 30c-7.175 4.142-9.633 13.316-5.49 20.49 4.155 7.197 13.336 9.62 20.49 5.49l51.962-30c7.175-4.142 9.633-13.315 5.49-20.49z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon-alert.81a114e763e529df50471749205cfe78.svg";
export { ForwardRef as ReactComponent };